import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const FaceIdRecognitionIcon: React.FC<IconProps> = ({
  color = 'currentColor',
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
}) => (
  <SvgWrapper aria-label="Face Id Recognition Icon" viewBox={viewBox} size={size}>
    <path
      fill={color}
      d="M2 20V4a2 2 0 0 1 2-2h3.076a.77.77 0 1 1 0 1.538H4A.462.462 0 0 0 3.538 4v16a.462.462 0 0 0 .462.462h3.076l.08.005a.77.77 0 0 1 0 1.53l-.08.004H4a2 2 0 0 1-2-2Zm18.462 0V4A.462.462 0 0 0 20 3.538h-3.077a.77.77 0 0 1 0-1.538H20a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2.001h-3.077a.77.77 0 0 1 0-1.539H20a.462.462 0 0 0 .462-.461Zm-5.355-4.767a.77.77 0 0 1 .976 1.187l-.22.191a6.25 6.25 0 0 1-7.982 0l-.219-.19-.056-.057a.77.77 0 0 1 1.032-1.13l.06.05.166.143a4.713 4.713 0 0 0 6.183-.144l.06-.05Zm-4.004-3.49V7.437a.77.77 0 0 1 1.538 0v4.308l-.009.197a2 2 0 0 1-1.793 1.793l-.197.009h-.616a.77.77 0 0 1 0-1.539h.616l.09-.009a.46.46 0 0 0 .363-.361l.008-.09ZM6.796 9.283V7.436a.77.77 0 1 1 1.538 0v1.846a.77.77 0 0 1-1.538 0Zm8.615 0V7.436a.77.77 0 0 1 1.538 0v1.846a.77.77 0 0 1-1.539 0Z"
    />
  </SvgWrapper>
)

export default FaceIdRecognitionIcon
